
/*
----------------------------
Module - smp-search-form
----------------------------
*/

import $ from 'jquery';

(function(){
    'use strict';

    squiz.fn.searchForms = function() {

        function setupSearchQueryFields() {

            var $search_query_fields = $search_forms.find(".smp-search-form__query-field");

            if ($search_query_fields.length) {

                $search_query_fields.each(function() {

                    var $this_search_query_field = $(this);

                    if ($this_search_query_field.hasClass("smp-search-form__query-field--autocomplete")) {

                        // Set up autocompletion
                        $this_search_query_field.autocompletion({

                            datasets: {
                                organic: {
                                    collection: "ab1139fa-568c-4c02-b1bb-9a5a8229a2c3~sp-hcc-web-meta",
                                    profile: "hcc-web-results",
                                    program: "https://dxp-au-search.funnelback.squiz.cloud/s/suggest.json",
                                    show: 5
                                }
                            },
                            logging: false,
                            length: 3
                        });

                    }

                });

            }

        }

        function init() {
        
            $search_forms = $(".smp-search-form");

            if ($search_forms.length) {

                setupSearchQueryFields();
                
            }

        }

        var $search_forms;
        
        return {
            init: init
        }

    }();
        
    document.addEventListener("DOMContentLoaded", function () {
        squiz.fn.searchForms.init();
    });

}());
